<template>
      <v-expansion-panel>
        <v-expansion-panel-title> Adnimisztrátorok </v-expansion-panel-title>
        <v-expansion-panel-text>
          <v-list>
            <v-list-item v-for="(admin, index) in admins" :key="index">
                <v-list-item-title>{{ admin.email }} <v-btn icon @click="confirmDeleteAdmin(admin.email)">
                  <v-icon>mdi-delete</v-icon>
                </v-btn></v-list-item-title>
            </v-list-item>
          </v-list>
          <v-divider></v-divider>
          <v-text-field
            v-model="newAdminEmail"
            label="Új adminisztrátor email címe"
            placeholder="Email"
          ></v-text-field>
          <v-btn @click="addAdmin" color="primary">Admin hozzáadása</v-btn>
        </v-expansion-panel-text>
      </v-expansion-panel>
    <v-dialog v-model="confirmDialog" max-width="400">
      <v-card>
        <v-card-title class="headline">Törlés megerősítése</v-card-title>
        <v-card-text
          >Biztosan ki szeretné törölni ezt az adminisztrátort?</v-card-text
        >
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="green darken-1" text @click="confirmDialog = false"
            >Mégsem</v-btn
          >
          <v-btn color="red darken-1" text @click="deleteAdmin">Törlés</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
</template>

<script>
import { getAllAdmins, deleteAdmin, postAdmin } from '../services/adminServices'

export default {
  name: 'AdminPanel',
  data() {
    return {
      admins: [],
      newAdminEmail: '',
      confirmDialog: false,
      emailToDelete: null,
    }
  },
  created() {
    this.fetchAdmins()
  },
  methods: {
    async fetchAdmins() {
      this.admins = await getAllAdmins()
    },
    async addAdmin() {
      if (this.newAdminEmail) {
        await postAdmin(this.newAdminEmail)
        this.newAdminEmail = ''
        this.fetchAdmins()
      }
    },
    confirmDeleteAdmin(email) {
      this.emailToDelete = email
      this.confirmDialog = true
    },
    async deleteAdmin() {
      if (this.emailToDelete) {
        await deleteAdmin(this.emailToDelete)
        this.emailToDelete = null
        this.confirmDialog = false
        this.fetchAdmins()
      }
    },
  },
}
</script>

<style scoped>
.v-expansion-panel-content {
  display: flex;
  flex-direction: column;
}
.v-list-item-action {
  display: flex;
  justify-content: flex-end;
}
</style>
